import {Injectable} from '@angular/core';
import {HeaderMetatada} from './header-metadata';
import {getValueAtWithArrays} from '@valg-shared/utils/object-utils';
import {saveFile} from "../../utils/file-utils";

@Injectable({
    providedIn: 'root',
})
export class ExportService {
    public Export<T>(filename: string, rows: T[], headers: HeaderMetatada[], canExportHeadersOnly = false) {
        const separator = ';';

        if (!rows || !rows.length) {
            if (canExportHeadersOnly) {
                this.exportCsvFile(headers.map((val) => val.title).join(separator), filename)
            } else {
                return;
            }
        }
        if(!(rows[0] instanceof Object)){
            return;
        }
        const keys: string[] = Object.keys(rows[0]);

        let columnHeaders: string[];

        if (headers) {
            columnHeaders = headers.map((val) => val.title);
        } else {
            columnHeaders = keys;
        }

        const csvContent =
            columnHeaders.join(separator) +
            '\n' +
            rows
                .map((row) => {
                    return headers
                        .map((k) => {
                            let cellContent = getValueAtWithArrays(row, k.path);
                            if (cellContent) {
                                cellContent =
                                    cellContent instanceof Date
                                        ? cellContent.toLocaleString()
                                        : cellContent.toString().replace(/"/g, '""');

                                cellContent = `"${cellContent}"`;
                            }
                            return cellContent ?? '';
                        })
                        .join(separator);
                })
                .join('\n');

        this.exportCsvFile(csvContent, filename)
    }

    private exportCsvFile(csvContent: string, filename: string) {

        const file = new File(["\ufeff" + csvContent], filename, { // add \ufeff for BOM character in Excel requirement
            type: 'text/csv;charset=utf-8;',
        });
        saveFile(file, filename);
    }
}
